import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const items = [{
  title: 'Sacrifici del weekend',
  desc: 'Sei stanco di rinunciare al sabato e alla domenica per preparare verifiche, correggere temi e strutturare la programmazione di Lettere.'
}, {
  title: 'Serate senza fine',
  desc: "Arrivi a casa esausto e devi ancora strutturare l'UDA della settimana, trovare testi letterari adatti e creare schede per gli studenti con difficoltà."
}, {
  title: 'Alunni "spenti"',
  desc: 'Senti che i tuoi studenti sono bloccati dalla letteratura "vecchio stile" e perdono motivazione davanti a Dante, Manzoni o Leopardi.'
}, {
  title: 'Programmazione di livello',
  desc: 'Vuoi presentare al Dirigente una programmazione moderna, visiva e in linea con le Indicazioni Nazionali MIM 2025/2026.'
}, {
  title: 'Materiali sempre aggiornati',
  desc: 'Cerchi schede, laboratori di scrittura e verifiche fresche senza dover ricominciare da capo ogni anno scolastico.'
}, {
  title: 'Tempo per la didattica',
  desc: "Vuoi smettere di fare il cercatore di materiali su internet e tornare a concentrarti sull'insegnare con passione."
}];
export function ForYouChecklist() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-card/50 border-y border-brand-orange/10 relative" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-121">
          Fatti riconoscere
        </p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-3 text-brand-cream" data-id="element-122">
          Questa risorsa è per te se ti riconosci qui sotto
        </motion.h2>
        <p className="text-center text-gray-400 text-sm mb-10" data-id="element-123">
          Basta che uno solo di questi punti ti rappresenti.
        </p>

        <div className="space-y-4" data-id="element-124">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex gap-4 items-start bg-brand-dark p-5 rounded-xl border border-white/5 hover:border-brand-orange/30 transition-colors" data-id="element-125">
              <CheckCircle2Icon className="w-6 h-6 sm:w-7 sm:h-7 text-green-500 shrink-0 mt-0.5" data-id="element-126" />
              <div data-id="element-127">
                <h3 className="text-base sm:text-lg font-bold text-brand-cream mb-1" data-id="element-128">
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-400 font-medium leading-relaxed" data-id="element-129">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center mt-8 text-brand-gold font-bold text-base sm:text-lg" data-id="element-130">
          ✓ Allora Lettere Pronte è stato pensato esattamente per te.
        </p>
      </div>
    </section>;
}